<template>
  <LoadingCom v-if="loading" />
  <div class="course" v-else>
    <CourseInformation :status="status" :info="info" :type="type" />
    <div class="list_box">
      <div class="tab">
        <div class="tab_item" v-for="item in tabList" :key="item.id" @click="changeTab(item.id)">
          <p :class="item.id == tabActive ? 'active' : 'opacity'">{{ item.text }}</p>
          <div class="line" :class="item.id == tabActive ? 'active_line' : ''"></div>
        </div>
      </div>
      <div class="live_box" v-if="tabActive == 0">
        <div class="live_box_title">本场直播</div>

        <div class="list" v-if="matchLiveData.length > 0">
          <CourseItem
            v-for="item in matchLiveData"
            :key="item.anchorId"
            :item="item"
            @click="
              router.push({
                name: 'Living',
                query: {
                  id: item.anchorId,
                  liveId: item.liveId,
                },
              })
            "
          />
        </div>
        <div class="empty" v-if="matchLiveData.length == 0 && finished">
          <img src="@/assets/img/icon/empty.png" alt="" class="empty_img" />
          <div class="text">暂无数据</div>
        </div>
      </div>
      <div class="text_live_box" v-if="tabActive == 1">
        <TextLive
          :type="type"
          :tabActive="tabActive"
          :awayTeamName="info.awayTeamName"
          :homeTeamName="info.homeTeamName"
        />
      </div>
    </div>
    <div class="download_box">
      <DownloadApp></DownloadApp>
    </div>
  </div>
</template>

<script setup name="Course">
import { useRouter } from "vue-router";
import CourseInformation from "./components/courseInformation.vue";
import CourseItem from "../../components/courseItem.vue";
import TextLive from "./components/textLive.vue";
import { onBeforeMount, onMounted, ref, onUnmounted } from "vue";
import { footballInfo } from "@/assets/api/footBallMatch.js";
import { basketballInfo } from "@/assets/api/basketBallMatch.js";
import { matchLiveList } from "@/assets/api/match.js";
const matchId = ref(0);
const type = ref(0);
const info = ref({});
const router = useRouter();
const loading = ref(true);
const finished = ref(false);
const matchLiveData = ref([]);

const tabActive = ref(0);
const status = ref("1"); //直播状态 1直播中 3未开始 2结束

const tabList = ref([
  {
    text: "视频直播",
    id: 0,
  },
  {
    text: "文字直播",
    id: 1,
  },
]);
function onLoad() {
  if (finished.value) {
  }
}
function changeTab(id) {
  tabActive.value = id;
}
function _footballInfo() {
  footballInfo(matchId.value)
    .then((res) => {
      info.value = res.data;
      loading.value = false;
    })
    .catch((err) => {
      loading.value = false;
    });
}
function _basketballInfo() {
  basketballInfo(matchId.value)
    .then((res) => {
      info.value = res.data;
      loading.value = false;
    })
    .catch((err) => {
      loading.value = false;
    });
}
function _matchLiveList() {
  matchLiveList({ matchId: matchId.value, matchType: type.value }).then((res) => {
    matchLiveData.value = res.data;
    finished.value = true;
  });
}

onMounted(() => {
  if (type.value == 1) {
    _footballInfo();
  } else {
    _basketballInfo();
  }
});

onBeforeMount(() => {
  matchId.value = router.currentRoute.value.query.matchId;
  type.value = router.currentRoute.value.query.type;

  _matchLiveList();
});
</script>
<style scoped>
.download_box {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0vw;
}
.course {
  position: fixed;
  left: 0;
  bottom: 0vw;
  top: 0;
  right: 0;
}
.list_box {
  border-top-left-radius: 3.2vw;
  border-top-right-radius: 3.2vw;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0vw;
  top: 53.86vw;
  right: 0;
  padding: 4.8vw 0vw;
  display: flex;
  flex-direction: column;
}
.tab {
  display: flex;
  align-items: center;
  margin-bottom: 5.33vw;
}
.tab_item {
  flex: 1;
  font-size: 3.73vw;
  line-height: 5.33vw;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.active {
  font-weight: 600;
}
.opacity {
  opacity: 0.45;
}
.line {
  width: 4.26vw;
  height: 4px;
  border-radius: 2px;
  background: transparent;
  flex-shrink: 0;
}
.active_line {
  background: #d8ad6d !important;
}

.live_box::-webkit-scrollbar {
  display: none;
}
.live_box,
.text_live_box {
  overflow-y: scroll;
  flex: 1;
  padding: 0 3.73vw;
}
.live_box_title {
  text-align: left;
  color: #000;
  font-family: PingFang SC;
  font-size: 4.26vw;
  font-weight: 600;
  line-height: 4.26vw;
}
.list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-top: 3.2vw;
}
.empty {
  height: 40vh;
  padding: 0 !important;
}
</style>
